import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Card,
  Box,
  CardHeader,
  Container,
  Link,
  Stack,
  SvgIcon,
  Typography,
  CardContent,
  Grid,
  TextField,
  IconButton,
  FormHelperText,
  DialogContent,
  Dialog,
  MenuItem,
  Divider,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Avatar,
  Autocomplete,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import * as Yup from "yup";
import {
  getFirestore,
  collection,
  getDocs,
  addDoc,
  setDoc,
  doc,
  getDoc,
  deleteDoc,
  query,
  where,
  updateDoc,
} from "firebase/firestore";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import ArrowRightIcon from "@untitled-ui/icons-react/build/esm/ArrowRight";
import Edit02Icon from "@untitled-ui/icons-react/build/esm/Edit02";
import { NavLink, useNavigate } from "react-router-dom";
import { QuillEditor } from "../../components/quill-editor";
import ArrowLeftIcon from "@untitled-ui/icons-react/build/esm/ArrowLeft";
import XIcon from "@untitled-ui/icons-react/build/esm/X";
import { Scrollbar } from "../../components/scrollbar";
import { addDays, format } from "date-fns";
import DeleteIcon from "@untitled-ui/icons-react/build/esm/Delete";

export function CadastroSessoes() {
  let navigate = useNavigate();

  const periodoOptions = [
    {
      label: "1° Período",
      value: "1",
    },
    {
      label: "2° Período",
      value: "2",
    },
  ];

  const tipoSessaoOptions = [
    {
      label: "Extraordinária",
      value: "extraordinaria",
    },
    {
      label: "Ordinária",
      value: "ordinaria",
    },
  ];

  const legislaturaOptions = [
    {
      label: "Legislatura (2025) - (2028)",
      value: "2025-2028",
    },
    {
      label: "Legislatura (2021) - (2024)",
      value: "2021-2024",
    },
    {
      label: "Legislatura (2016) - (2020)",
      value: "2016-2020",
    },
  ];

  const tipoStatusSessao = [
    {
      label: "Aberta",
      value: "aberta",
    },
    {
      label: "Rascunho",
      value: "rascunho",
    },
    {
      label: "Fechada",
      value: "fechada",
    },
  ];

  const simplesOptions = [
    {
      label: "Todos os tipos",
      value: "todos-tipos",
    },
    {
      label: "Projeto de resolução",
      value: "projetoResolucao",
    },
    {
      label: "Emenda",
      value: "emenda",
    },
    {
      label: "Indicação",
      value: "indicacao",
    },
    {
      label: "Projeto de Decreto Legislativo",
      value: "projetoDecretoLegislativo",
    },
    {
      label: "Projeto de emenda à Lei orgânica",
      value: "projetoEmendaLeiOrganica",
    },
    {
      label: "Projeto de Lei Ordinária",
      value: "projetoLeiOrdinaria",
    },
    {
      label: "Projeto de Lei do Poder Executivo",
      value: "projetoLeiPoderExecutivo",
    },
    {
      label: "Projeto de Lei do Poder Legislativo",
      value: "projetoLeiPoderLegislativo",
    },
    {
      label: "Projeto Substitutivo",
      value: "projetoSubstitutivo",
    },
    {
      label: "Requerimento",
      value: "requerimento",
    },
    {
      label: "Subemenda",
      value: "subemenda",
    },
    {
      label: "Veto",
      value: "veto",
    },
    {
      label: "Pareceres das Comições",
      value: "pareceresComicoes",
    },
    {
      label: "Parecer",
      value: "parecer",
    },
    {
      label: "Mensagem",
      value: "mensagem",
    },
  ];

  const removeHtmlTags = (textoHTML?: string) => {
    if (!textoHTML) return "";
    const div = document.createElement("div");
    div.innerHTML = textoHTML;
    return div.textContent || div.innerText || "";
  };

  const getPautaTipoLabel = (pautaLegislativa?: string) => {
    const tipo = simplesOptions.find((opcao) => opcao.value === pautaLegislativa);
    return tipo?.label || "Tipo não informado";
  };

  const getEtapaPautaLabel = (pauta: any) => {
    if (pauta?.opcoesVotacao !== "2-turnos") {
      return pauta?.votada ? "Finalizada" : "Disponível";
    }
    const votos1turno = Array.isArray(pauta?.votos1turno)
      ? pauta.votos1turno.length
      : 0;
    const votos2turno = Array.isArray(pauta?.votos2turno)
      ? pauta.votos2turno.length
      : 0;
    const concluiuPrimeiroTurno = votos1turno > 0 && votos2turno === 0;
    const concluiuSegundoTurno = votos2turno > 0;
    const statusAtual = pauta?.statusAtual;

    if (statusAtual === "votacao2turno") return "Em 2º turno";
    if (statusAtual === "votacao1turno") return "Em 1º turno";
    if (
      (statusAtual === "votado" || statusAtual === "finalizada") &&
      concluiuPrimeiroTurno
    ) {
      return "2º turno pendente";
    }
    if (concluiuPrimeiroTurno) return "2º turno pendente";
    if (concluiuSegundoTurno || pauta?.votada) return "2 turnos concluídos";
    return "Disponível";
  };

  const isPautaDisponivelParaSessao = (pauta: any) => {
    if (!pauta) return false;

    const isDoisTurnos = pauta.opcoesVotacao === "2-turnos";
    const votos1turno = Array.isArray(pauta.votos1turno)
      ? pauta.votos1turno.length
      : 0;
    const votos2turno = Array.isArray(pauta.votos2turno)
      ? pauta.votos2turno.length
      : 0;
    const concluiuPrimeiroTurno = votos1turno > 0 && votos2turno === 0;
    const concluiuSegundoTurno = votos2turno > 0;

    if (!isDoisTurnos) {
      return !pauta.votada;
    }

    if (pauta.statusAtual === "votacao1turno" || pauta.statusAtual === "votacao2turno") {
      return true;
    }

    if (concluiuPrimeiroTurno) {
      return true;
    }

    if (concluiuSegundoTurno) {
      return false;
    }

    return !pauta.votada;
  };

  const [openModalEditAta, setOnOpenModalEditAta] = useState(false);
  const [open, setOnOpen] = useState(false);
  const [openPauta, setOnOpenPauta] = useState(false);
  const [pautas, setPautas] = useState([]);
  const [codeSessao, setCodeSessao] = useState("");
  const [atas, setAtas] = useState([]);
  const [pautasSessao, setPautasSessao] = useState([]);
  const [adicionarPautaLoading, setAdicionarPautaLoading] = useState(false);
  const [parlamentares, setParlamentares] = useState([]);

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(db, "users", `belacruz@eleg`, "pautas");
    // Buscar todas as pautas e filtrar no lado do cliente para incluir pautas em primeiro turno
    const queryRef = query(ordersRef);

    getDocs(queryRef)
      .then((querySnapshot) => {
        const parsedData = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          // Cria um objeto com as propriedades e seus respectivos valores
          const obj = {
            id: doc.id,
            ...data,
            // Adicione outras propriedades e seus valores aqui, se necessário
          };
          return obj;
        });

        const filteredData = parsedData.filter((pauta) =>
          isPautaDisponivelParaSessao(pauta)
        );

        //@ts-ignore
        setPautas(filteredData);
      })
      .catch((error) => {
        console.log("Erro ao recuperar dados da subcoleção:", error);
      });

    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let code = "";

    for (let i = 0; i < 20; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      code += characters.charAt(randomIndex);
    }

    const ordersRefParlamentar = collection(
      db,
      "users",
      "belacruz@eleg",
      "parlamentares"
    );
    const queryRefParlamentar = query(
      ordersRefParlamentar,
      where("legislatura", "==", "Legislatura (2025) - (2028)"),
      where("parlamentarEstado", "==", "ativo")
    );

    getDocs(queryRefParlamentar).then((querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        // Cria um objeto com as propriedades e seus respectivos valores
        const obj = {
          id: doc.id,
          ...data,
          // Adicione outras propriedades e seus valores aqui, se necessário
        };
        return obj;
      });

      //@ts-ignore
      setParlamentares(parsedData);
    });

    setCodeSessao(code);
  }, []);

  const formik = useFormik({
    initialValues: {
      legislatura: "",
      sessao: "",
      tipoSessao: "",
      dataSessao: "",
      statusSessao: "",
      idPauta: "",
      tituloAtaExpediente: "",
      textoAta: "",
      idAta: "",
      periodo: "",
      submit: null,
    },
    validationSchema: Yup.object({
      legislatura: Yup.string().max(255).required("O campo é obrigatório"),
      periodo: Yup.string().max(255).required("O campo é obrigatório"),
      sessao: Yup.string().max(255).required("O campo é obrigatório"),
      tipoSessao: Yup.string().max(255),
      dataSessao: Yup.string().max(255).required("O campo é obrigatório"),
      idPauta: Yup.string(),
      tituloAtaExpediente: Yup.string().max(255),
      textoAta: Yup.string(),
    }),
    onSubmit: async (values, helpers) => {
      try {
        const db = getFirestore();
        const colecaoPaiRef = collection(db, "users");
        const novoDocumentoRef = doc(colecaoPaiRef, "belacruz@eleg");
        const subcolecaoRef = collection(novoDocumentoRef, "sessoes");
        const novoDocumentocCdeSessaoRef = doc(subcolecaoRef, codeSessao);

        setDoc(novoDocumentocCdeSessaoRef, {
          legislatura:
            values.legislatura !== undefined ? values.legislatura : undefined,
          sessao: values.sessao !== undefined ? values.sessao : undefined,
          tipoSessao:
            values.tipoSessao !== undefined ? values.tipoSessao : undefined,
          periodo: values.periodo !== undefined ? values.periodo : undefined,
          dataSessao:
            values.dataSessao !== undefined
              ? format(addDays(new Date(values.dataSessao), 1), "yyyy-MM-dd")
              : undefined,
          statusSessao: "rascunho",
          hibridaSessao: true,
          statusConfigSessao: 1,
        });

        // Realizar consultas adicionais para cada documento retornado pela primeira consulta
        await Promise.all(
          parlamentares.map(async (parlamentar) => {
            const colecaoPaiRef = collection(db, "users");

            const novoDocumentoRef = doc(colecaoPaiRef, "belacruz@eleg");
            const subcolecaosSessoesRef = collection(
              novoDocumentoRef,
              "sessoes"
            );
            const subcolecaosSessaoRef = doc(
              subcolecaosSessoesRef,
              `${codeSessao}`
            );
            const subcolecaopequenoExpeRef = collection(
              subcolecaosSessaoRef,
              "grande-expediente"
            );
            const subcolecaosSessaoDocRef = doc(
              subcolecaopequenoExpeRef,
              //@ts-ignore
              `${parlamentar.id}`
            );
            await setDoc(subcolecaosSessaoDocRef, {
              //@ts-ignore
              ...parlamentar,
              momento: new Date(),
              solicitacao: false,
              status: false,
              tempo: 10,
            });
          })
        );

        // Realizar consultas adicionais para cada documento retornado pela primeira consulta
        await Promise.all(
          parlamentares.map(async (parlamentar) => {
            const colecaoPaiRef = collection(db, "users");

            const novoDocumentoRef = doc(colecaoPaiRef, "belacruz@eleg");
            const subcolecaosSessoesRef = collection(
              novoDocumentoRef,
              "sessoes"
            );
            const subcolecaosSessaoRef = doc(
              subcolecaosSessoesRef,
              `${codeSessao}`
            );
            const subcolecaopequenoExpeRef = collection(
              subcolecaosSessaoRef,
              "presencaParlamentares"
            );
            //@ts-ignore
            const subcolecaosSessaoDocRef = doc(
              subcolecaopequenoExpeRef,
              //@ts-ignore
              `${parlamentar.id}`
            );
            await setDoc(subcolecaosSessaoDocRef, {
              //@ts-ignore
              nome: parlamentar.nomeParlamentar,
              //@ts-ignore
              partido: parlamentar.partido,
              presenca: false,
            });
          })
        );

        navigate("/sessoes");

        helpers.setStatus({ success: true });
        helpers.setSubmitting(false);
        toast.success("Customer updated");
      } catch (err) {
        console.error(err);
        toast.error("Something went wrong!");
        helpers.setStatus({ success: false });
        //@ts-ignore
        helpers.setErrors({ submit: err.message });
        helpers.setSubmitting(false);
      }
    },
  });

  const pautasSessaoIds = new Set(
    (pautasSessao as any[]).map((item: any) => item.idPauta).filter(Boolean)
  );
  const pautasDisponiveis = (pautas as any[]).filter(
    (pauta: any) =>
      isPautaDisponivelParaSessao(pauta) && !pautasSessaoIds.has(pauta.id)
  );
  const pautaSelecionada =
    (pautasDisponiveis as any[]).find(
      (pauta: any) => pauta.id === formik.values.idPauta
    ) || null;

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 4,
      }}
    >
      <Dialog fullWidth maxWidth="md" open={openModalEditAta}>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          spacing={3}
          sx={{
            px: 3,
            py: 2,
          }}
        >
          <Typography variant="h6">Editar Ata</Typography>
          <IconButton
            color="inherit"
            onClick={() => {
              setOnOpenModalEditAta(!openModalEditAta);
            }}
          >
            <SvgIcon>
              <XIcon />
            </SvgIcon>
          </IconButton>
        </Stack>

        <DialogContent>
          <form>
            <Stack spacing={4}>
              <Grid container justifyContent="space-between">
                <TextField
                  error={
                    !!(
                      formik.touched.tituloAtaExpediente &&
                      formik.errors.tituloAtaExpediente
                    )
                  }
                  fullWidth
                  helperText={
                    formik.touched.tituloAtaExpediente &&
                    formik.errors.tituloAtaExpediente
                  }
                  label="Titulo Ata do Exepediente"
                  name="tituloAtaExpediente"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.tituloAtaExpediente}
                />

                <div
                  style={{
                    marginTop: 20,
                    width: "100%",
                  }}
                >
                  <Typography color="InfoText" sx={{ mb: 2 }} variant="h6">
                    Texto da Ata
                  </Typography>
                  <QuillEditor
                    onChange={(value) => {
                      formik.setFieldValue("textoAta", value);
                    }}
                    placeholder="Adicione o texto..."
                    sx={{ height: 350 }}
                    value={formik.values.textoAta}
                  />
                </div>
              </Grid>
            </Stack>

            <Stack
              direction={{
                xs: "column",
                sm: "row",
              }}
              flexWrap="wrap"
              spacing={3}
              sx={{ pt: 3 }}
            >
              <Button
                disabled={
                  formik.values.textoAta !== "" &&
                  formik.values.tituloAtaExpediente !== ""
                    ? false
                    : true
                }
                variant="contained"
                onClick={() => {
                  const db = getFirestore();

                  const ordersRefAtasId = doc(
                    db,
                    "users",
                    `belacruz@eleg`,
                    "sessoes",
                    `${codeSessao}`,
                    "atas",
                    `${formik.values.idAta}`
                  );

                  updateDoc(ordersRefAtasId, {
                    textoAta: formik.values.textoAta,
                    tituloAtaExpediente: formik.values.tituloAtaExpediente,
                  });

                  formik.setFieldValue("textoAta", "");
                  formik.setFieldValue("tituloAtaExpediente", "");

                  setOnOpenModalEditAta(!openModalEditAta);
                }}
              >
                Adicionar
              </Button>
              <Button
                color="inherit"
                onClick={() => {
                  setOnOpenModalEditAta(!openModalEditAta);
                }}
                disabled={formik.isSubmitting}
              >
                Cancelar
              </Button>
            </Stack>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog fullWidth maxWidth="sm" open={open}>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          spacing={3}
          sx={{
            px: 3,
            py: 2,
          }}
        >
          <Typography variant="h6">Adicionar Ata</Typography>
          <IconButton
            color="inherit"
            onClick={() => {
              setOnOpen(!open);
            }}
          >
            <SvgIcon>
              <XIcon />
            </SvgIcon>
          </IconButton>
        </Stack>

        <DialogContent>
          <form>
            <Stack spacing={4}>
              <Grid container justifyContent="space-between">
                <TextField
                  error={
                    !!(
                      formik.touched.tituloAtaExpediente &&
                      formik.errors.tituloAtaExpediente
                    )
                  }
                  fullWidth
                  helperText={
                    formik.touched.tituloAtaExpediente &&
                    formik.errors.tituloAtaExpediente
                  }
                  label="Titulo Ata do Exepediente"
                  name="tituloAtaExpediente"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.tituloAtaExpediente}
                />

                <div
                  style={{
                    marginTop: 20,
                    width: "100%",
                  }}
                >
                  <Typography color="InfoText" sx={{ mb: 2 }} variant="h6">
                    Texto da Ata
                  </Typography>
                  <QuillEditor
                    onChange={(value) => {
                      formik.setFieldValue("textoAta", value);
                    }}
                    placeholder="Adicione o texto..."
                    sx={{ height: 350 }}
                    value={formik.values.textoAta}
                  />
                </div>
              </Grid>
            </Stack>

            <Stack
              direction={{
                xs: "column",
                sm: "row",
              }}
              flexWrap="wrap"
              spacing={3}
              sx={{ pt: 3 }}
            >
              <Button
                disabled={
                  formik.values.textoAta !== "" &&
                  formik.values.tituloAtaExpediente !== ""
                    ? false
                    : true
                }
                variant="contained"
                onClick={() => {
                  const db = getFirestore();
                  const colecaoPaiRef = collection(db, "users");
                  const novoDocumentoRef = doc(colecaoPaiRef, "belacruz@eleg");
                  const subcolecaoSessaoRef = collection(
                    novoDocumentoRef,
                    "sessoes"
                  );
                  const novoDocumentoCodeSessao = doc(
                    subcolecaoSessaoRef,
                    codeSessao
                  );
                  const subcolecaoPautaRef = collection(
                    novoDocumentoCodeSessao,
                    "atas"
                  );

                  addDoc(subcolecaoPautaRef, {
                    tituloAtaExpediente:
                      formik.values.tituloAtaExpediente !== undefined
                        ? formik.values.tituloAtaExpediente
                        : undefined,
                    textoAta:
                      formik.values.textoAta !== undefined
                        ? formik.values.textoAta
                        : undefined,
                  }).catch((error) => {
                    console.error("Error writing document:", error);
                  });

                  const ordersRefAtas = collection(
                    db,
                    "users",
                    `belacruz@eleg`,
                    "sessoes",
                    `${codeSessao}`,
                    "atas"
                  );

                  getDocs(ordersRefAtas)
                    .then((querySnapshot) => {
                      const parsedData = querySnapshot.docs.map((doc) => {
                        const data = doc.data();
                        // Cria um objeto com as propriedades e seus respectivos valores
                        const obj = {
                          id: doc.id,
                          textoAta: data.textoAta,
                          tituloAtaExpediente: data.tituloAtaExpediente,
                          // Adicione outras propriedades e seus valores aqui, se necessário
                        };
                        return obj;
                      });

                      //@ts-ignore
                      setAtas(parsedData);

                      const db = getFirestore();
                      const colecaoPaiRef = collection(db, "users");
                      const novoDocumentoRef = doc(
                        colecaoPaiRef,
                        "belacruz@eleg"
                      );
                      const subcolecaoRef = collection(
                        novoDocumentoRef,
                        "sessoes"
                      );
                      const novoDocumentocCdeSessaoRef = doc(
                        subcolecaoRef,
                        codeSessao
                      );

                      setDoc(novoDocumentocCdeSessaoRef, {
                        legislatura:
                          formik.values.legislatura !== undefined
                            ? formik.values.legislatura
                            : undefined,
                        sessao:
                          formik.values.sessao !== undefined
                            ? formik.values.sessao
                            : undefined,
                        tipoSessao:
                          formik.values.tipoSessao !== undefined
                            ? formik.values.tipoSessao
                            : undefined,
                        dataSessao: format(new Date(), "yyyy-MM-dd"),
                        statusSessao: "rascunho",
                        statusConfigSessao: 1,
                      });
                    })
                    .catch((error) => {
                      console.log(
                        "Erro ao recuperar dados da subcoleção:",
                        error
                      );
                    });

                  formik.setFieldValue("textoAta", "");
                  formik.setFieldValue("tituloAtaExpediente", "");

                  setOnOpen(!open);
                }}
              >
                Adicionar
              </Button>
              <Button
                color="inherit"
                onClick={() => {
                  setOnOpen(!open);
                }}
                disabled={formik.isSubmitting}
              >
                Cancelar
              </Button>
            </Stack>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog fullWidth maxWidth="md" open={openPauta}>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          spacing={3}
          className="bg-gradient-to-r from-[#0f172a] via-[#1e293b] to-[#0f172a] px-6 pt-5 pb-4"
        >
          <div>
            <Typography className="!text-white !font-semibold" variant="h6">
              Adicionar Pauta legislativa
            </Typography>
            <Typography className="!text-slate-300" variant="body2">
              Busque por número, autor, tipo ou trecho da descrição.
            </Typography>
          </div>
          <IconButton
            className="!text-white/90 hover:!bg-white/10"
            onClick={() => {
              setOnOpenPauta(!openPauta);
            }}
          >
            <SvgIcon>
              <XIcon />
            </SvgIcon>
          </IconButton>
        </Stack>

        <DialogContent className="!p-0">
          <form>
            <Stack spacing={4} className="bg-slate-50 p-6">
              <Stack
                spacing={2}
                className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm"
              >
                <div className="flex items-center justify-between">
                  <span className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                    Pautas elegíveis
                  </span>
                  <span className="rounded-full bg-blue-100 px-3 py-1 text-xs font-semibold text-blue-700">
                    {pautasDisponiveis.length} disponíveis
                  </span>
                </div>

                <Autocomplete
                  options={pautasDisponiveis as any[]}
                  value={pautaSelecionada}
                  onChange={(_, value: any) => {
                    formik.setFieldValue("idPauta", value?.id || "");
                  }}
                  isOptionEqualToValue={(option: any, value: any) =>
                    option.id === value.id
                  }
                  getOptionLabel={(option: any) =>
                    option.numeroProtocolo ||
                    option.numero ||
                    option.autor ||
                    "Pauta sem identificação"
                  }
                  ListboxProps={{ className: "!p-2 !max-h-[22rem]" }}
                  PaperComponent={(paperProps: any) => (
                    <div
                      {...paperProps}
                      className={`mt-2 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl ${
                        paperProps.className || ""
                      }`}
                    />
                  )}
                  noOptionsText="Nenhuma pauta disponível para adicionar."
                  filterOptions={(options, state) =>
                    options.filter((option: any) => {
                      const search = state.inputValue.toLowerCase();
                      const content = [
                        option.numero,
                        option.numeroProtocolo,
                        option.autor,
                        getPautaTipoLabel(option.pautaLegislativa),
                        removeHtmlTags(option.expressoes),
                      ]
                        .filter(Boolean)
                        .join(" ")
                        .toLowerCase();
                      return content.includes(search);
                    })
                  }
                  renderOption={(props, option: any) => {
                    const resumo = removeHtmlTags(option.expressoes);
                    return (
                      <li
                        {...props}
                        key={option.id}
                        className={`${(props as any).className || ""} !my-1 !block !bg-transparent !p-0`}
                      >
                        <div className="group w-full rounded-xl border border-slate-200 bg-slate-50/80 p-3 transition-all hover:border-blue-300 hover:bg-blue-50/80">
                          <div className="flex flex-wrap items-center gap-2">
                            <span className="text-sm font-semibold text-slate-800">
                              {option.numeroProtocolo || option.numero || "Sem número"}
                            </span>
                            <span className="rounded-full border border-slate-300 bg-white px-2 py-0.5 text-xs font-medium text-slate-700">
                              {option.opcoesVotacao === "2-turnos"
                                ? "2 turnos"
                                : "Simples"}
                            </span>
                            <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700">
                              {getEtapaPautaLabel(option)}
                            </span>
                          </div>
                          <p className="mt-1 text-xs text-slate-500">
                            Autor:{" "}
                            <span className="font-medium text-slate-700">
                              {option.autor || "Não informado"}
                            </span>
                          </p>
                          <p className="mt-1 text-xs text-slate-500">
                            Tipo:{" "}
                            <span className="font-medium text-slate-700">
                              {getPautaTipoLabel(option.pautaLegislativa)}
                            </span>
                          </p>
                          <p className="mt-2 text-sm text-slate-700">
                            {resumo.length > 140
                              ? `${resumo.substring(0, 140)}...`
                              : resumo}
                          </p>
                        </div>
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <div>
                      <TextField
                        {...params}
                        label="Buscar e selecionar pauta"
                        placeholder="Ex: 17/2025, Prefeitura, Projeto de Lei..."
                        error={!!(formik.touched.idPauta && formik.errors.idPauta)}
                      />
                      <p className="mt-2 text-xs text-slate-500">
                        {pautasDisponiveis.length > 0
                          ? "Inclui pautas pendentes e pautas de 2 turnos com 1º turno concluído."
                          : "Não há pautas elegíveis para esta sessão no momento."}
                      </p>
                    </div>
                  )}
                />

                {pautaSelecionada && (
                  <div className="rounded-2xl border border-blue-200 bg-gradient-to-r from-blue-50 via-white to-indigo-50 p-4 shadow-sm">
                    <p className="text-xs font-semibold uppercase tracking-wide text-blue-700">
                      Pauta selecionada
                    </p>
                    <div className="mt-2 flex flex-wrap items-center gap-2">
                      <span className="text-base font-semibold text-slate-900">
                        {pautaSelecionada.numeroProtocolo ||
                          pautaSelecionada.numero ||
                          "Sem número"}
                      </span>
                      <span className="rounded-full border border-slate-300 bg-white px-2 py-0.5 text-xs font-medium text-slate-700">
                        {getPautaTipoLabel(pautaSelecionada.pautaLegislativa)}
                      </span>
                      <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700">
                        {getEtapaPautaLabel(pautaSelecionada)}
                      </span>
                    </div>
                    <p className="mt-2 text-sm text-slate-600">
                      Autor:{" "}
                      <span className="font-medium text-slate-800">
                        {pautaSelecionada.autor || "Não informado"}
                      </span>
                    </p>
                    <p className="mt-1 text-sm text-slate-700">
                      {removeHtmlTags(pautaSelecionada.expressoes).substring(
                        0,
                        220
                      )}
                      {removeHtmlTags(pautaSelecionada.expressoes).length > 220
                        ? "..."
                        : ""}
                    </p>
                  </div>
                )}

                {!pautaSelecionada && pautasDisponiveis.length > 0 && (
                  <div className="rounded-xl border border-dashed border-slate-300 bg-slate-100/70 p-3 text-sm text-slate-600">
                    Selecione uma pauta para visualizar os detalhes antes de
                    adicionar.
                  </div>
                )}
                {!pautaSelecionada && pautasDisponiveis.length === 0 && (
                  <div className="rounded-xl border border-dashed border-slate-300 bg-slate-100/70 p-3 text-sm text-slate-600">
                    Não existem pautas pendentes para inclusão agora.
                  </div>
                )}
              </Stack>
            </Stack>

            <Stack
              direction={{
                xs: "column",
                sm: "row",
              }}
              flexWrap="wrap"
              spacing={3}
              sx={{
                pt: 3,
                px: 3,
                pb: 3,
                borderTop: "1px solid #e2e8f0",
                backgroundColor: "#fff",
              }}
            >
              <LoadingButton
                loading={adicionarPautaLoading}
                disabled={formik.values.idPauta !== "" ? false : true}
                variant="contained"
                onClick={async () => {
                  setAdicionarPautaLoading(true);

                  const db = getFirestore();
                  const colecaoPaiRef = collection(db, "users");
                  const novoDocumentoRef = doc(colecaoPaiRef, "belacruz@eleg");
                  const subcolecaoSessaoRef = collection(
                    novoDocumentoRef,
                    "sessoes"
                  );
                  const novoDocumentoCodeSessao = doc(
                    subcolecaoSessaoRef,
                    `${codeSessao}`
                  );
                  const subcolecaoPautaRef = collection(
                    novoDocumentoCodeSessao,
                    "pautas"
                  );

                  const docRef = doc(
                    db,
                    "users",
                    `belacruz@eleg`,
                    "pautas",
                    formik.values.idPauta
                  );
                  const docSnap = await getDoc(docRef);

                  addDoc(subcolecaoPautaRef, {
                    idPauta:
                      formik.values.idPauta !== undefined
                        ? formik.values.idPauta
                        : undefined,
                    votado: false,
                    leituraVis: false,
                  })
                    .then(async () => {
                      const db = getFirestore();

                      const consulta1Snapshot = await getDocs(
                        collection(
                          db,
                          "users",
                          "belacruz@eleg",
                          "sessoes",
                          `${codeSessao}`,
                          "pautas"
                        )
                      );

                      //@ts-ignore
                      const resultadosAdicionais = [];

                      // Realizar consultas adicionais para cada documento retornado pela primeira consulta
                      await Promise.all(
                        consulta1Snapshot.docs.map(async (docSnapshot) => {
                          //@ts-ignore
                          const documentoRef = doc(
                            db,
                            "users",
                            "belacruz@eleg",
                            "pautas",
                            docSnapshot.data().idPauta
                          );
                          const consultaAdicionalSnapshot = await getDoc(
                            documentoRef
                          );
                          resultadosAdicionais.push({
                            ...consultaAdicionalSnapshot.data(),
                            id: docSnapshot.id,
                            idPauta: (docSnapshot as any).idPauta,
                          });
                        })
                      );

                      //@ts-ignore
                      setPautasSessao(resultadosAdicionais);
                      setOnOpenPauta(!openPauta);
                      setAdicionarPautaLoading(false);

                      formik.setFieldValue("idPauta", "");

                      const colecaoPaiRef = collection(db, "users");
                      const novoDocumentoRef = doc(
                        colecaoPaiRef,
                        "belacruz@eleg"
                      );
                      const subcolecaoRef = collection(
                        novoDocumentoRef,
                        "sessoes"
                      );
                      const novoDocumentocCdeSessaoRef = doc(
                        subcolecaoRef,
                        `${codeSessao}`
                      );

                      setDoc(novoDocumentocCdeSessaoRef, {
                        legislatura:
                          formik.values.legislatura !== undefined
                            ? formik.values.legislatura
                            : undefined,
                        sessao:
                          formik.values.sessao !== undefined
                            ? formik.values.sessao
                            : undefined,
                        tipoSessao:
                          formik.values.tipoSessao !== undefined
                            ? formik.values.tipoSessao
                            : undefined,
                        dataSessao: format(
                          addDays(new Date(), 1),
                          "yyyy-MM-dd"
                        ),
                        statusSessao: formik.values.statusSessao,
                        statusConfigSessao: 1,
                      });
                    })
                    .catch((error) => {
                      console.error("Error writing document:", error);
                    });
                }}
              >
                Adicionar
              </LoadingButton>

              <Button
                color="inherit"
                onClick={() => {
                  setOnOpenPauta(!openPauta);
                }}
                disabled={formik.isSubmitting}
              >
                Cancelar
              </Button>
            </Stack>
          </form>
        </DialogContent>
      </Dialog>

      <Container maxWidth="lg">
        <Stack spacing={4}>
          <div>
            <NavLink to="/sessoes">
              <Link
                color="text.primary"
                sx={{
                  alignItems: "center",
                  display: "inline-flex",
                }}
                underline="hover"
              >
                <SvgIcon sx={{ mr: 1 }}>
                  <ArrowLeftIcon />
                </SvgIcon>
                <Typography variant="subtitle2">Voltar</Typography>
              </Link>
            </NavLink>
          </div>

          <Stack
            alignItems="flex-start"
            direction={{
              xs: "column",
              md: "row",
            }}
            justifyContent="space-between"
            spacing={4}
          >
            <Stack alignItems="center" direction="row" spacing={2}>
              <Stack spacing={1}>
                <Typography variant="h4">
                  Cadastro das Sessões Plenárias
                </Typography>
              </Stack>
            </Stack>
          </Stack>

          <form onSubmit={formik.handleSubmit}>
            <Card>
              <CardContent sx={{ pt: 1 }}>
                <Grid container justifyContent="space-between">
                  <Grid marginTop={3} xs={12} md={5.85}>
                    <TextField
                      error={
                        !!(
                          formik.touched.legislatura &&
                          formik.errors.legislatura
                        )
                      }
                      fullWidth
                      label="Legislatura"
                      name="legislatura"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      select
                      value={formik.values.legislatura}
                    >
                      {legislaturaOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid marginTop={3} xs={12} md={5.85}>
                    <TextField
                      error={!!(formik.touched.sessao && formik.errors.sessao)}
                      fullWidth
                      helperText={formik.touched.sessao && formik.errors.sessao}
                      label="Sessão"
                      name="sessao"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.sessao}
                    />
                  </Grid>
                  <Grid marginTop={3} xs={12} md={5.85}>
                    <TextField
                      error={
                        !!(
                          formik.touched.tipoSessao && formik.errors.tipoSessao
                        )
                      }
                      fullWidth
                      label="Tipo Sessão"
                      name="tipoSessao"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      select
                      value={formik.values.tipoSessao}
                    >
                      {tipoSessaoOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid marginTop={3} xs={12} md={5.85}>
                    <TextField
                      error={
                        !!(
                          formik.touched.dataSessao && formik.errors.dataSessao
                        )
                      }
                      fullWidth
                      helperText={
                        formik.touched.dataSessao && formik.errors.dataSessao
                      }
                      label="Data da Sessão"
                      name="dataSessao"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.dataSessao}
                      type={"date"}
                    />
                  </Grid>
                  <Grid marginTop={3} xs={12} md={5.85}>
                    <TextField
                      error={
                        !!(
                          formik.touched.statusSessao &&
                          formik.errors.statusSessao
                        )
                      }
                      fullWidth
                      label="Status da Sessão"
                      name="statusSessao"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      select
                      value={formik.values.statusSessao}
                    >
                      {tipoStatusSessao.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid marginTop={3} xs={12} md={5.85}>
                    <TextField
                      error={
                        !!(formik.touched.periodo && formik.errors.periodo)
                      }
                      fullWidth
                      label="Período"
                      name="periodo"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      select
                      value={formik.values.periodo}
                    >
                      {periodoOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </CardContent>

              <Divider
                sx={{
                  marginTop: 2,
                }}
              />

              <CardHeader
                title="Atas do Expediente"
                action={
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={() => {
                      setOnOpen(!open);
                    }}
                  >
                    Adicionar Ata
                  </Button>
                }
              />

              <CardContent sx={{ pt: 1 }}>
                <Scrollbar>
                  <Table sx={{ minWidth: 600 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Título</TableCell>
                        <TableCell>Texto da Ata</TableCell>
                        <TableCell align="right">Ações</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {atas !== undefined &&
                        atas.map((item: any) => {
                          //@ts-ignore
                          function removeTags(textoHTML) {
                            const div = document.createElement("div");
                            div.innerHTML = textoHTML;
                            return div.textContent || div.innerText || "";
                          }

                          return (
                            <TableRow
                              hover
                              //@ts-ignore
                              key={item.id}
                            >
                              <TableCell>
                                <Typography variant="subtitle1">
                                  {/*@ts-ignore*/}
                                  {item.tituloAtaExpediente}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                {/*@ts-ignore*/}
                                {removeTags(item.textoAta).slice(0, 300)}...
                              </TableCell>
                              <TableCell align="right">
                                <IconButton
                                  onClick={() => {
                                    const db = getFirestore();

                                    //@ts-ignore
                                    const ordersRef = doc(
                                      db,
                                      "users",
                                      "belacruz@eleg",
                                      "sessoes",
                                      `${codeSessao}`,
                                      "atas",
                                      //@ts-ignore
                                      `${item.id}`
                                    );

                                    deleteDoc(ordersRef).then(() => {
                                      setAtas([]);
                                    });
                                  }}
                                >
                                  <Tooltip title="Apagar">
                                    <SvgIcon>
                                      <DeleteIcon />
                                    </SvgIcon>
                                  </Tooltip>
                                </IconButton>
                                <IconButton
                                  onClick={() => {
                                    setOnOpenModalEditAta(!openModalEditAta);

                                    formik.setFieldValue(
                                      "textoAta",
                                      item.textoAta
                                    );
                                    formik.setFieldValue(
                                      "tituloAtaExpediente",
                                      item.tituloAtaExpediente
                                    );

                                    formik.setFieldValue("idAta", item.id);
                                  }}
                                >
                                  <Tooltip title="Editar">
                                    <SvgIcon>
                                      <Edit02Icon />
                                    </SvgIcon>
                                  </Tooltip>
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </Scrollbar>
              </CardContent>

              <Divider
                sx={{
                  marginTop: 2,
                }}
              />

              <CardHeader
                title="Pauta legislativas"
                action={
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={() => {
                      setOnOpenPauta(!openPauta);
                    }}
                  >
                    Adicionar pautas
                  </Button>
                }
              />

              <CardContent sx={{ pt: 1 }}>
                <Scrollbar>
                  <Table sx={{ minWidth: 600 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Número</TableCell>
                        <TableCell>Autor</TableCell>
                        <TableCell>Tipo da pauta</TableCell>
                        <TableCell>Descrição</TableCell>
                        <TableCell align="right">Ações</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {pautasSessao !== undefined &&
                        pautasSessao.map((item) => {
                          //@ts-ignore
                          const labelCorrespondente = simplesOptions.find(
                            //@ts-ignore
                            (opcao) => opcao.value === item.pautaLegislativa
                          );

                          //@ts-ignore
                          function removeTags(textoHTML) {
                            const div = document.createElement("div");
                            div.innerHTML = textoHTML;
                            return div.textContent || div.innerText || "";
                          }

                          return (
                            <TableRow
                              hover
                              //@ts-ignore
                              key={item.id}
                            >
                              <TableCell>
                                {/*@ts-ignore*/}
                                {item.numero}
                              </TableCell>
                              <TableCell>
                                {/*@ts-ignore*/}
                                {item.autor === undefined
                                  ? `Não informado`
                                  : //@ts-ignore
                                    item.autor}
                              </TableCell>
                              <TableCell>
                                {/*@ts-ignore*/}
                                {labelCorrespondente?.label}
                              </TableCell>
                              <TableCell>
                                {/*@ts-ignore*/}
                                {removeTags(item.expressoes)}
                              </TableCell>
                              <TableCell align="right">
                                <IconButton
                                  onClick={() => {
                                    const db = getFirestore();

                                    //@ts-ignore
                                    const ordersRef = doc(
                                      db,
                                      "users",
                                      "belacruz@eleg",
                                      "sessoes",
                                      `${codeSessao}`,
                                      "pautas",
                                      //@ts-ignore
                                      `${item.id}`
                                    );

                                    deleteDoc(ordersRef)
                                      .then(() => {
                                        console.log(
                                          "Document successfully deleted!"
                                        );
                                      })
                                      .catch((error) => {
                                        console.error(
                                          "Error removing document: ",
                                          error
                                        );
                                      });
                                  }}
                                >
                                  <Tooltip title="Apagar">
                                    <SvgIcon>
                                      <DeleteIcon />
                                    </SvgIcon>
                                  </Tooltip>
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </Scrollbar>
              </CardContent>

              <Stack
                direction={{
                  xs: "column",
                  sm: "row",
                }}
                flexWrap="wrap"
                spacing={3}
                sx={{ p: 3 }}
              >
                <Button
                  disabled={formik.isSubmitting}
                  type="submit"
                  variant="contained"
                >
                  Cadastrar
                </Button>
                <Button
                  color="inherit"
                  onClick={() => {
                    navigate("/sessoes");
                  }}
                  disabled={formik.isSubmitting}
                >
                  Cancelar
                </Button>
              </Stack>
            </Card>
          </form>
        </Stack>
      </Container>
    </Box>
  );
}
